import axios from "axios";

const apiURL = process.env.REACT_APP_API_URL; 

export const RegisterUser = async (name, email, referrer, password, mobile) => {
  try {
    const response = await axios.post(`${apiURL}auth/createuser`, {
      name: name,
      email: email,
      password: password,
      phone: mobile,
      referrer: referrer || null,
    });

    if (response.message === "Passwords do not match") {
      throw new Error("Invalid password");
    }

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    // console.log(error.response.data.error)
    if (error.response && error.response.data && error.response.data.error) {
      throw new Error(error.response.data.error);
    } else {
      throw new Error("Failed to Register!");
    }
  }
};

export const OTPVerification = async (userId, otp) => {
  try {
    const response = await axios.post(`${apiURL}auth/verify-otp`, {
      userId: userId,
      enteredOTP: otp,
    });

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error.response && error.response.data && error.response.data.error) {
      throw new Error(error.response.data.error);
    } else {
      throw new Error("Failed to verify OTP!");
    }
  }
};


export const LoginUser = async (email, password) => {
  try {
    const response = await axios.post(`${apiURL}auth/login`, {
      email: email,
      password: password,
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error("Invalid Login Credentials!");
    }
  } catch (error) {
    if (error.response && error.response.data && error.response.data.error) {
      throw new Error(error.response.data.error);
    } else {
      throw new Error("Failed to Login!");
    }
  }
};


  export const GetReferralName = async (_id) => {
    try {
      const response = await axios.get(`${apiURL}referral/getreferralname/${_id}`);
      console.log(response)
      if (response.status === 200) {
        return response.data;
      }
  
    } catch (error) {
        throw new Error("Invalid User ID!");

    }
  };